import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IcpIntelJobDto } from '../../../shared/dto';
import { AggregateApiService } from '../../../shared/services/api';
import { DEFAULT_KEY_VALUE_MODEL, KeyValueModel } from '../../../shared/models';
import { CacheService } from '../../../shared/services';

const ICP_INTEL_MODEL_CACHE_KEY: string = 'ICP_INTEL_MODEL_CACHE_KEY';

@Injectable({
  providedIn: 'root'
})
export class IcpIntelModelService {

  constructor(private aggregateApiService: AggregateApiService, private cacheService: CacheService) {
  }

  setIcpIntelModel(item: KeyValueModel): void {
    if (item) {
      this.safeCacheSet(item.key, item)
    }
  }

  getIcpIntelModel(key: string): Observable<KeyValueModel> {
    return of(key).pipe(
      switchMap((key: string) => {
        if (!key) {
          return of(DEFAULT_KEY_VALUE_MODEL);
        } else {
          const item: KeyValueModel = this.safeCacheGet(key);
          return item ? of(item) : this.loadAndStoreModel(key);
        }
      }),
    )
  }

  private loadAndStoreModel(key: string): Observable<KeyValueModel>{
    return this.aggregateApiService.getAggregationJobByUUID(key).pipe(
      map((job: IcpIntelJobDto) => job ? { key: job.job_uuid, value: job.job_name } : null),
      map((item: KeyValueModel) => item ? this.safeCacheSet(key, item) : DEFAULT_KEY_VALUE_MODEL)
    )
  }

  private safeCacheGet(key: string): KeyValueModel {
    const cache: Map<string, KeyValueModel> = this.cacheService.get(ICP_INTEL_MODEL_CACHE_KEY);
    return cache ? cache.get(key) : null;
  }

  private safeCacheSet(key: string, value: KeyValueModel): KeyValueModel {
    const cache: Map<string, KeyValueModel> = this.cacheService.get(ICP_INTEL_MODEL_CACHE_KEY) || new Map<string, KeyValueModel>();
    this.cacheService.set(ICP_INTEL_MODEL_CACHE_KEY, cache.set(key, value));
    return value;
  }
}
